/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

export const SORT_FIELDS_FRAGMENT = /* GraphQL */ `
  fragment SortFieldsFragment on SortFields {
    default
    options {
      label
      value
    }
  }
`;
